<template>
    <div>
        <van-skeleton title avatar :row="3" :loading="loading">
            <div class="flex-info">
                <div
                    class="img-box"
                    v-if="item.products && item.products.length > 0"
                >
                    <img
                        :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.products[0].imageUrl}`"
                        width="100"
                        height="100"
                    />
                </div>
                <div
                    class="mission-info-box"
                    v-if="item.products && item.products.length > 0"
                >
                    <p class="mission-name">{{ item.products[0].name }}</p>
                    <p>
                        ￥
                        {{
                            item.status && item.products[0].price | priceFilter
                        }}
                        元
                        <span class="free-tip">免费赠送</span>
                    </p>
                    <p>
                        <img
                            :src="
                                item.platform && item.platform.value === 50
                                    ? pIcon[10]
                                    : pIcon[20]
                            "
                            width="20"
                        />
                        {{
                            item.platform && item.platform.value === 50
                                ? "大众点评发稿"
                                : "朋友圈发稿"
                        }}
                    </p>
                </div>
            </div>
            <template v-if="source === 'shop' && item.status">
                <p
                    class="mission-status-info mission-going"
                    v-if="item.status && item.status.value === 30"
                >
                    剩余名额：{{
                        item.needPeople - item.applySuccessTotal
                    }}
                    参与人数：{{ item.applySuccessTotal }} 结束时间：{{ time }}
                </p>
                <p
                    class="mission-status-info mission-else"
                    v-if="
                        item.status &&
                        (item.status.value === 5 ||
                            item.status.value === 10 ||
                            item.status.value === 20)
                    "
                >
                    剩余名额：{{ item.needPeople }} 参与人数：0 结束时间：{{
                        resolveTime
                    }}小时后
                </p>
                <p
                    class="mission-status-info mission-else"
                    v-if="
                        (item.status && item.status.value === 40) ||
                        (item.status && item.status.value === 50)
                    "
                >
                    参与人数：{{ item.applySuccessTotal }} 执行时间：{{
                        resolveTime
                    }}小时
                </p>
                <div class="mission-bottom" v-if="item.status.value !== 10">
                    <span
                        class="publish-time"
                        v-if="
                            item.status.value !== 5 &&
                            item.status.value !== 10 &&
                            item.status.value !== 20
                        "
                        >发布时间：{{ this.item.gmtCreate }}</span
                    >
                    <span
                        class="mission-opt-text"
                        v-if="item.status.value === 30"
                        >进行中</span
                    >
                    <button
                        v-if="
                            item.status.value === 20 ||
                            item.status.value === 5 ||
                            item.status.value === 40 ||
                            item.status.value === 50
                        "
                        class="mission-opt-btn"
                        @click="goMissionPage(item)"
                    >
                        {{
                            item.status.value === 5 || item.status.value === 20
                                ? "编辑"
                                : "再次发布"
                        }}
                    </button>
                </div>
            </template>
            <slot></slot>
            <template v-if="source === 'profit'">
                <div class="shop-info">
                    <div class="shop-info-text">
                        <p>
                            <img
                                width="16"
                                src="../../../assets/jike/shop.png"
                            />{{ addressInfo.realName }}
                        </p>
                        <p>
                            <img
                                width="16"
                                src="../../../assets/jike/map.png"
                            />{{ addressInfo.province }}{{ addressInfo.city
                            }}{{ addressInfo.district
                            }}{{ addressInfo.address }}区
                        </p>
                    </div>
                    <!--                    <div class="shop-info-contact">-->
                    <!--                        <p>-->
                    <!--                            <img width="16" src="../../assets/jike/navigator.png" @click="wakeBaidu"/>-->
                    <!--                            <span>|</span>-->
                    <!--                            <img width="16" src="../../assets/jike/phone.png"/>-->
                    <!--                        </p>-->
                    <!--                    </div>-->
                </div>
            </template>
        </van-skeleton>
    </div>
</template>
<script>
import { fetchTaskDetail, fetchAddressById } from "../../../services/instant";
import round from "lodash.round";
import moment from "moment";

const PLATFROM_ICON = {
    10: require("../../../assets/platformImg/dz.png"),
    20: require("../../../assets/platformImg/wechat.png"),
};
export default {
    props: {
        taskId: {
            type: String,
            default: "",
        },
        source: {
            type: String,
            default: "shop",
        },
    },
    filters: {
        priceFilter(value) {
            if (!value) {
                return "0";
            }
            // 将整数部分逢三一断
            return round(value / 100)
                .toFixed(2)
                .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        },
    },
    data() {
        return {
            loading: true,
            addressInfo: {},
            item: {},
            now: new Date(),
            pIcon: PLATFROM_ICON,
        };
    },
    computed: {
        resolveTime() {
            let date1;
            if (this.item.status.value === 5) {
                date1 = moment(this.item.gmtModified);
            } else {
                date1 = moment(this.item.gmtCreate);
            }
            // 任务创建时间
            const date2 = moment(this.item.applyEndTime); // 报名结束时间
            const date3 = date2.diff(date1, "minute"); // 计算相差的分钟数
            const h = Math.ceil(date3 / 60); // 相差的小时数
            return h;
        },
        time() {
            // 获取当前时间
            const date = this.now;
            const now = date.getTime();
            // 设置截止时间
            const str = this.item.applyEndTime;
            const endDate = new Date(str.replace(/-/g, "/"));
            const end = endDate.getTime();

            // 时间差
            const leftTime = end - now;
            let h, m, s;
            if (leftTime >= 0) {
                // d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
                h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                m = Math.floor((leftTime / 1000 / 60) % 60);
                s = Math.floor((leftTime / 1000) % 60);
            }
            // d = d > 9 ? d : '0' + d
            h = h > 9 ? h : "0" + h;
            m = m > 9 ? m : "0" + m;
            s = s > 9 ? s : "0" + s;
            // setTimeout(this.restTime, 1000)
            return `${h}:${m}:${s}`;
        },
        //
    },
    mounted() {
        this.getTaskDetail();
    },
    methods: {
        async getTaskDetail() {
            const item = await fetchTaskDetail(this.taskId);
            this.item = item.data;
            this.getAddress(this.item.merchantAddressId);
            this.loading = false;
            this.now = new Date();
            this.timer = setInterval(() => {
                this.now = new Date();
            }, 1000);
        },
        goMissionPage(item) {
            this.$router.push({
                path: "/missionDetail",
                query: {
                    id: item.id,
                    optType:
                        item.status.value === 5 || item.status.value === 20
                            ? "edit"
                            : "copy",
                },
            });
        },
        getAddress(id) {
            fetchAddressById(id).then((res) => {
                this.addressInfo = res.data;
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
<style lang="less" scoped>
.mission-container {
    .free-tip {
        background: rgba(255, 109, 38, 0.3);
        color: #ff6d26;
        font-size: 10px;
        display: inline-block;
        transform: scale(0.8);
        padding: 2px;
        position: relative;
        top: -8px;
    }
    box-sizing: border-box;
    padding: 10px;
    width: 360px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin: 0 auto 10px;
    .shop-info {
        &-text {
            display: table-cell;
            width: 100%;

            p {
                font-size: 12px;

                img {
                    vertical-align: middle;
                    margin-right: 5px;
                }

                &:nth-of-type(1) {
                    color: #000000;
                    font-weight: bold;

                    span {
                        color: #807f7f;
                    }
                }

                &:nth-of-type(2) {
                    color: #807f7f;
                }
            }
        }

        &-contact {
            display: table-cell;
            width: 80px;
            vertical-align: bottom;

            p {
                width: 60px;

                span {
                    color: #dadada;
                    padding: 0 10px;
                }

                img {
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }
    }
    .flex-info {
        .img-box {
            display: table-cell;
            vertical-align: middle;
            img {
                border-radius: 5px;
            }
        }
        .mission-info-box {
            word-break: break-all;
            padding-left: 15px;
            display: table-cell;
            font-size: 12px;
            color: #171f24;
            img {
                vertical-align: middle;
            }
        }
    }
    .mission-bottom {
        height: 40px;
        line-height: 40px;
    }
    .mission-status-info {
        //height: 30px;
        line-height: 30px;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        font-size: 12px;
        padding: 5px;
        &.mission-going {
            color: #ff0000;
            background: rgba(244, 32, 32, 0.15);
        }
        &.mission-else {
            color: #ffffff;
            background: #838383;
        }
    }
    .mission-opt-btn {
        width: 80px;
        height: 25px;
        line-height: 25px;
        background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        border-radius: 3px;
        color: #ffffff;
        font-size: 12px;
        border: none;
        float: right;
        margin-top: 7px;
    }
    .mission-opt-text {
        line-height: 40px;
        float: right;
        color: #fa6400;
        font-size: 12px;
    }
    .publish-time {
        color: #171f24;
        font-size: 12px;
    }
}
</style>
